module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mz-dcf8977ee74002921810a1e8014a57a1.svg";